/**
 * Pre-bootstrap theme initialization
 *
 * Import and call this function BEFORE bootstrapping Angular
 * to ensure theme colors are applied before first render
 *
 * Usage in main.ts:
 *
 * ```typescript
 * import { initThemeBeforeBootstrap } from '@nexu-library/ui-kit';
 *
 * // Initialize theme BEFORE bootstrapping
 * initThemeBeforeBootstrap();
 *
 * // Then bootstrap Angular
 * bootstrapApplication(AppComponent, appConfig);
 * ```
 */

import { initializeDynamicTheme } from "./dynamic-theme-loader";

/**
 * Initialize theme before Angular bootstraps
 * This ensures dynamic colors are applied immediately
 */
export function initThemeBeforeBootstrap(): void {
  initializeDynamicTheme();
}
